"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractStates = void 0;
const extractStates = (actuators) => {
    const states = [];
    for (const actuator of actuators) {
        states.push({
            actuatorId: actuator.id,
            updatedTime: new Date(actuator.state.updatedTime),
            state: {
                dim: actuator.state.dim,
                power: actuator.state.power,
            },
        });
    }
    return states;
};
exports.extractStates = extractStates;
//# sourceMappingURL=States.js.map